import LoyaltyMembersDayBanner from "../../components/LoyaltyMembersDay/Banner";

import { useSelector } from "react-redux";
import { getCategoryId } from "../../state/modules/category";
import {
  getIsBenefitAvailable,
  getLoyaltyMemberOnlySaleEvent,
  getStoreCode
} from "../../state/modules/config/selectors";
import { MEMBERS_ONLY_SALE } from "../../state/modules/config/constants";

const ConnectedLoyaltyMembersDayBanner = props => {
  const categoryId = useSelector(getCategoryId);
  const isBenefitAvailable = useSelector(getIsBenefitAvailable);
  const membersDayEvent = useSelector(getLoyaltyMemberOnlySaleEvent);
  const storeCode = useSelector(getStoreCode);

  return (
    <LoyaltyMembersDayBanner
      {...props}
      categoryId={categoryId}
      isMembersDayAvailable={isBenefitAvailable?.[MEMBERS_ONLY_SALE]}
      membersDayEvent={membersDayEvent}
      storeCode={storeCode}
    />
  );
};

export default ConnectedLoyaltyMembersDayBanner;
